<template>
  <section class="p-2">
    <div>
      <v-form>
        <v-card class="">
          <v-card-title class="d-flex justify-space-between p-0 m-0">
            <div class="ps-2 headingFontsize">Edit Bank</div>
            <div>
              <bread-crumb
                :bread-crumbs="['Partner Summary', 'Bank List', 'Edit Bank']"
              />
            </div>
          </v-card-title>
          <v-divider class="p-0 m-0 primary--text"></v-divider>
          <!-- <v-toolbar flat dense>
            <v-toolbar-title>Edit Bank/Location</v-toolbar-title>
          </v-toolbar> -->
          <!-- <div style="border:solid 1px;color:grey" class="ms-4 me-4"></div> -->
          <!-- <v-divider   style="border: solid 1px;color: green;  "></v-divider> -->
          <v-card-text>
            <v-row class="mt-2 ms-1 me-1">
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">Location Name</label>
                <v-text-field
                  outlined
                  dense
                  class="rounded"
                  placeholder="Location Name"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">Country</label>
                <v-autocomplete
                  outlined
                  dense
                  class="rounded"
                  placeholder="Country"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">Payout Partner</label>
                <v-autocomplete
                  outlined
                  dense
                  class="rounded"
                  placeholder="Payout Partner"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">Payment Type</label>
                <v-autocomplete
                  outlined
                  dense
                  class="rounded"
                  placeholder="Payment Type"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="ms-1 me-1">
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">External Bank Id</label>
                <v-text-field
                  outlined
                  dense
                  class="rounded"
                  placeholder="External Bank Id"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">External Bank Id2</label>
                <v-text-field
                  outlined
                  dense
                  class="rounded"
                  placeholder="External Bank Id2"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">External Bank Id3</label>
                <v-text-field
                  outlined
                  dense
                  class="rounded"
                  placeholder="External Bank Id3"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-switch
                  class="py-3"
                  hide-details
                  label="Is selected agent Primary agent ? "
                ></v-switch>
              </v-col>
            </v-row>
            <v-row class="ms-1 me-1">
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">Priority List Order</label>
                <v-text-field
                  outlined
                  dense
                  class="rounded"
                  placeholder="External Bank Id"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">SLA MESSAGE</label>
                <v-text-field
                  outlined
                  dense
                  class="rounded"
                  placeholder="External Bank Id2"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">PAYOUT AMOUNT LIMIT</label>
                <v-text-field
                  outlined
                  dense
                  class="rounded"
                  placeholder="External Bank Id3"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <div class="row">
              <div
                class="col-md-12"
                style="display: flex; justify-content: end"
              >
                <v-btn depressed  small class="text-capitalize me-2 mb-10" color="primary"
                  >Update</v-btn
                >
                <v-btn depressed 
                  small
                  class="text-capitalize me-5 mb-10"
                  color="primary"
                  outlined
                  ><v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel</v-btn
                >
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-form>
    </div>
  </section>
</template>
<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name:"Edit Bank",
  data: () => ({}),
  components: {
    BreadCrumb,
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
